import { useTranslation } from 'react-i18next'

import { ProfileIcon } from '@mercai/clever'

import { CardInfo } from '@/components/card-info'
import { CardOrderProductsSupplierProps } from './card-order-products-supplier.type'
import { formatLongDate } from '@/helpers'

export const CardOrderProductsSupplier = ({
  isLoading,
  actions,
  supplier,
  supplierPaidAt,
}: CardOrderProductsSupplierProps) => {
  const { t } = useTranslation('componentCardsOrderCenterShow')

  return (
    <CardInfo
      icon={<ProfileIcon />}
      title={t('cardOrderProductsSupplierTitle')}
      isLoading={isLoading}
      actions={actions}
      items={[
        {
          label: t('cardOrderProductsSupplierName'),
          value: supplier?.name || '-',
        },
        {
          label: t('cardOrderProductsSupplierEmail'),
          value: supplier?.email || '-',
        },
        {
          label: t('cardOrderProductsSupplierPhone'),
          value: supplier?.phone || '-',
        },
        {
          label: t('cardOrderProductsSupplierPaidAt'),
          value: supplierPaidAt ? formatLongDate(supplierPaidAt) : '-',
        },
      ]}
    />
  )
}
